import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { REPORTS_INIT_LOADING, REPORTS_INIT_SUCCESS, REPORTS_INIT_FAIL, REPORTS_AGENCY_INIT_LOADING, REPORTS_AGENCY_INIT_SUCCESS, REPORTS_AGENCY_INIT_FAIL, REPORTS_HISTORY_UPDATE, REPORTS_HISTORY_FAVOURITE_UPDATE,
  REPORTS_HISTORY_INIT_LOADING, REPORTS_HISTORY_INIT_SUCCESS, REPORTS_HISTORY_INIT_FAIL, REPORTS_HISTORY_FAVOURITE_INIT_LOADING, REPORTS_HISTORY_FAVOURITE_INIT_SUCCESS, REPORTS_HISTORY_FAVOURITE_INIT_FAIL,
  REPORTS_HISTORY_LOADMORE_LOADING, REPORTS_HISTORY_LOADMORE_SUCCESS, REPORTS_HISTORY_LOADMORE_FAIL, REPORTS_CLAIMS_INIT_LOADING, REPORTS_CLAIMS_INIT_SUCCESS, REPORTS_CLAIMS_INIT_FAIL } from '@/store/types'

export const state = {
  init: 0,
  initErr: [],
  menu: {},
  agencyReports: {
    init: 0,
    initErr: [],
    menu: {}
  },
  rptHistoryList: {
    init: 0,
    menu: {},
    jobs: [],
    loadingNewRptHistory: false,
    hasNext: true,
    lastId: 0
  },
  favRptHistoryList: {
    init: 0,
    menu: {},
    jobs: [],
    loadingNewRptHistory: false,
    hasNext: true,
    lastId: 0
  },
  claimsReports: {
    init: 0,
    initErr: [],
    menu: {}
  }
}

export const getters = {
}

export const mutations = {
  [REPORTS_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [REPORTS_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [REPORTS_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [REPORTS_AGENCY_INIT_LOADING](state) {
    state.agencyReports.init = 0
    state.agencyReports.initErr = []
    state.agencyReports.menu = {}
  },
  [REPORTS_AGENCY_INIT_SUCCESS](state, data) {
    state.agencyReports.init = 1
    state.agencyReports.initErr = []
    state.agencyReports.menu = data.menu
  },
  [REPORTS_AGENCY_INIT_FAIL](state, error) {
    state.agencyReports.init = 2
    state.agencyReports.initErr = error
    state.agencyReports.menu = {}
  },
  [REPORTS_HISTORY_INIT_LOADING](state) {
    state.rptHistoryList.init = 0
  },
  [REPORTS_HISTORY_INIT_SUCCESS](state, data) {
    state.rptHistoryList.init = 1
    state.rptHistoryList.menu = data.menu
    state.rptHistoryList.jobs = data.data.jobList

    if (data.data.jobList && data.data.jobList.length > 0) {
      state.rptHistoryList.hasNext = true
      state.rptHistoryList.lastId = data.data.jobList[data.data.jobList.length - 1].id
    } else {
      state.rptHistoryList.hasNext = false
      state.rptHistoryList.lastId = 0
    }
  },
  [REPORTS_HISTORY_INIT_FAIL](state) {
    state.rptHistoryList.init = 2
  },
  [REPORTS_HISTORY_FAVOURITE_INIT_LOADING](state) {
    state.favRptHistoryList.init = 0
  },
  [REPORTS_HISTORY_FAVOURITE_INIT_SUCCESS](state, data) {
    state.favRptHistoryList.init = 1
    state.favRptHistoryList.menu = data.menu
    state.favRptHistoryList.jobs = data.data.jobList

    if (data.data.jobList && data.data.jobList.length > 0) {
      state.favRptHistoryList.hasNext = true
      state.favRptHistoryList.lastId = data.data.jobList[data.data.jobList.length - 1].id
    } else {
      state.favRptHistoryList.hasNext = false
      state.favRptHistoryList.lastId = 0
    }
  },
  [REPORTS_HISTORY_FAVOURITE_INIT_FAIL](state) {
    state.favRptHistoryList.init = 2
  },
  [REPORTS_HISTORY_LOADMORE_LOADING](state) {
    state.rptHistoryList.loadingNewRptHistory = true
  },
  [REPORTS_HISTORY_LOADMORE_SUCCESS](state, data) {
    // Reload the menu (the next link)
    state.rptHistoryList.menu = data.menu

    if (data.data.jobList && data.data.jobList.length > 0) {
      // Append new notifications
      state.rptHistoryList.jobs.push.apply(state.rptHistoryList.jobs, data.data.jobList)
      state.rptHistoryList.hasNext = true
      state.rptHistoryList.lastId = data.data.jobList[data.data.jobList.length - 1].id
    } else {
      state.rptHistoryList.hasNext = false
    }

    state.rptHistoryList.loadingNewRptHistory = false
  },
  [REPORTS_HISTORY_LOADMORE_FAIL](state) {
    state.rptHistoryList.loadingNewRptHistory = false
  },
  [REPORTS_HISTORY_UPDATE](state, data) {
    state.rptHistoryList.jobs.map((item) => {
      if (item.id === data.id) {
        item.favourite = data.favourite
        if (data.favourite === true) {
          state.favRptHistoryList.jobs.unshift(item)
        } else {
          const index = state.favRptHistoryList.jobs.findIndex(a => a.id === data.id)
          state.favRptHistoryList.jobs.splice(index, 1)
        }
      }
    })
  },
  [REPORTS_HISTORY_FAVOURITE_UPDATE](state, data) {
    state.favRptHistoryList.jobs.map((item) => {
      if (item.id === data.id) {
        item.favourite = data.favourite
        if (!data.favourite) {
          const index = state.favRptHistoryList.jobs.findIndex(a => a.id === data.id)
          state.favRptHistoryList.jobs.splice(index, 1)
        }
      }
    })
    state.rptHistoryList.jobs.map((item) => {
      if (item.id === data.id) {
        item.favourite = data.favourite
      }
    })
  },
  [REPORTS_CLAIMS_INIT_LOADING](state) {
    state.claimsReports.init = 0
    state.claimsReports.initErr = []
    state.claimsReports.menu = {}
  },
  [REPORTS_CLAIMS_INIT_SUCCESS](state, data) {
    state.claimsReports.init = 1
    state.claimsReports.initErr = []
    state.claimsReports.menu = data.menu
  },
  [REPORTS_CLAIMS_INIT_FAIL](state, error) {
    state.claimsReports.init = 2
    state.claimsReports.initErr = error
    state.claimsReports.menu = {}
  }
}

export const actions = {
  async reportsInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.reports
    commit(REPORTS_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(REPORTS_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_INIT_FAIL, extractMessages(error))
    }
  },
  async agencyReportsInit({ commit, state }) {
    const apiUrl = state.menu.agencyReports
    commit(REPORTS_AGENCY_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(REPORTS_AGENCY_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_AGENCY_INIT_FAIL, extractMessages(error))
    }
  },
  async claimsReportsInit({ commit, state }) {
    const apiUrl = state.menu.claimsReports
    commit(REPORTS_CLAIMS_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(REPORTS_CLAIMS_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(REPORTS_CLAIMS_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
